"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  WifiSignal2: ['wifi-signal-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.750 10.319 A2.250 2.250 0 1 0 14.250 10.319 A2.250 2.250 0 1 0 9.750 10.319 Z', 'M12 12.569L12 22.253', 'M19.286,18.89a11.249,11.249,0,0,0,0-17.143', 'M16.371,15.462a6.749,6.749,0,0,0,0-10.286', 'M4.714,18.89a11.249,11.249,0,0,1,0-17.143', 'M7.629,15.462a6.749,6.749,0,0,1,0-10.286']],
  WifiSignal: ['wifi-signal', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12 11.997L12 23.247', 'M20.426,19.45a11.25,11.25,0,1,0-16.852,0', 'M15.22,13.919a3.75,3.75,0,1,0-6.44,0', 'M17.84,15.85a7.5,7.5,0,1,0-11.68,0']],
  RssFeedSquare: ['rss-feed-square', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 0.747 L23.250 0.747 L23.250 23.247 L0.750 23.247 Z', 'M5.250 16.497 A2.250 2.250 0 1 0 9.750 16.497 A2.250 2.250 0 1 0 5.250 16.497 Z', 'M5.205,10.126a6.807,6.807,0,0,1,8.4,9.36', 'M5.359,5.445a11.279,11.279,0,0,1,13,14.08']],
  WifiSignal3: ['wifi-signal-3', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M7.5 23.247L12 11.247 12 8.247 12 11.247 16.5 23.247', 'M7.759,9.755a4.5,4.5,0,1,1,8.48.007', 'M6.712,13.566a7.5,7.5,0,1,1,10.577,0', 'M4.5 23.247L19.5 23.247', 'M1.125 22.497L1.125 22.497', 'M1.125,22.5a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375', 'M22.875 22.497L22.875 22.497', 'M22.875,22.5a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375']],
  WifiSignal5: ['wifi-signal-5', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M8.25 23.247L12 15.747 15.75 23.247', 'M12 15.747L12 9.747', 'M12 0.747L12 3.747', 'M5.636 3.383L7.757 5.505', 'M3 9.747L6 9.747', 'M5.636 16.111L7.757 13.99', 'M18.364 16.111L16.243 13.99', 'M21 9.747L18 9.747', 'M18.364 3.383L16.243 5.505', 'M4.5 23.247L19.5 23.247', 'M1.125 22.497L1.125 22.497', 'M1.125,22.5a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375', 'M22.875 22.497L22.875 22.497', 'M22.875,22.5a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375']],
  WifiSignal4: ['wifi-signal-4', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M7.5 23.248L12 11.248 12 8.248 12 11.248 16.5 23.248', 'M17.726.747a9,9,0,0,1,0,15', 'M16.5,4.575a5.249,5.249,0,0,1,0,7.347', 'M6.275.747a9,9,0,0,0,0,15', 'M7.5,4.575a5.251,5.251,0,0,0,0,7.347', 'M8.625 20.248L15.375 20.248']],
  WifiSignal1: ['wifi-signal-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.500 11.952 A1.500 1.500 0 1 0 13.500 11.952 A1.500 1.500 0 1 0 10.500 11.952 Z', 'M15.712,8.24a5.249,5.249,0,0,1,0,7.425', 'M8.288,15.665a5.249,5.249,0,0,1,0-7.425', 'M17.834,6.119a8.251,8.251,0,0,1,0,11.667', 'M6.166,17.786a8.249,8.249,0,0,1,0-11.667', 'M19.955,4a11.251,11.251,0,0,1,0,15.91', 'M4.045,19.907A11.251,11.251,0,0,1,4.045,4']],
  RssFeed: ['rss-feed', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 19.497 A3.750 3.750 0 1 0 8.250 19.497 A3.750 3.750 0 1 0 0.750 19.497 Z', 'M.75,8.844a11.328,11.328,0,0,1,14.4,14.4', 'M.75,1.113A18.777,18.777,0,0,1,22.889,23.236']]
};
exports["default"] = _default;